var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mx-auto",attrs:{"width":_vm.width,"outlined":"","elevation":"1"}},[_vm._t("content")],2)}
var staticRenderFns = []

export { render, staticRenderFns }